import {
  CalendarItemType,
  MealRecipe,
  MealType,
  User,
} from '@akin-home/amplify';
import { CalendarItem, HasEndDate } from '@akin-home/calendar';
import { RecordWithImageFields } from '@akin-home/images';
import { Recipe } from '@akin-home/recipes';
import { HasID } from '@akin-home/records';
import { Recurrable } from '@akin-home/recurrence';

export interface Meal
  extends HasID,
    CalendarItem,
    HasEndDate,
    RecordWithImageFields,
    Recurrable<Meal> {
  type: CalendarItemType.Meal;
  mealType: MealType;
  habitatID: string;
  emoji?: string;

  /** The calendar item's title */
  title: string;
  notes?: string;
  ingredients: IngredientItem[];
  prepNotes: PreparationNote[];

  participantIDS?: string[];
  participants?: User[];

  /** Linked Recipe Records */
  recipes: Recipe[];

  /** Many2many items that link recipes to the meal */
  recipeM2m: MealRecipe[];

  // highlightedRecipe?: Recipe;

  location?: string;

  /** Legacy image url field */
  publicImageUrl?: string;

  cachedImageUrl?: string;

  eaten?: boolean;
  recommended?: boolean;
  acceptedRecommended?: boolean;

  updatedAt?: string;
  createdAt?: string;
}

export interface IngredientItem {
  id: string;
  title: string;
  checked: boolean;
  shoppingListID: string;
}

export interface PreparationNote {
  id: string;
  description: string;
  title?: string;
}

export enum MealPlanPreferenceStateVariableNames {
  BUDGET = 'Meal_budget_range',
  PEOPLE = 'Meal_number_people',
  DIFFICULTY = 'Meal_difficulty',
  DIET_TYPE = 'Meat_type_diet',

  // Allergies
  DAIRY_ALLERGY = 'User_dairy_allergy',
  EGG_ALLERGY = 'User_egg_allergy',
  PEANUT_ALLERGY = 'User_peanut_allergy',
  SESAME_ALLERGY = 'User_sesame_allergy',
  SHELLFISH_ALLERGY = 'User_shellfish_allergy',
  SOY_ALLERGY = 'User_soy_allergy',
  TREENUT_ALLERGY = 'User_treenut_allergy',
  WHEAT_ALLERGY = 'User_wheat_allergy',

  /** Eats meat */
  EATS_MEAT = 'User_eats_meat',
  EATS_BEEF = 'User_eats_beef',
  EATS_LAMB = 'User_eats_lamb',
  EATS_PORK = 'User_eats_pork',
  EATS_CHICKEN = 'User_eats_chicken',
  EATS_TURKEY = 'User_eats_turkey',
  EATS_FISH = 'User_eats_fish',

  /** Meal inclusions */
  PLAN_BREAKFAST = 'User_include_breakfast',
  PLAN_LUNCH = 'User_include_lunch',
  PLAN_DINNER = 'User_include_dinner',
  PLAN_SNACK = 'User_include_snack',

  /** Meal times */
  BREAKFAST_TIME = 'User_breakfast_time',
  LUNCH_TIME = 'User_lunch_time',
  DINNER_TIME = 'User_dinner_time',
  SNACK_TIME = 'User_snack_time',

  /** Reminders */
  BREAKFAST_REMINDER = 'User_breakfast_reminder',
  LUNCH_REMINDER = 'User_lunch_reminder',
  DINNER_REMINDER = 'User_dinner_reminder',
  SNACK_REMINDER = 'User_snack_reminder',
}